import {useContext} from "react";
import {ChangesContext, ToastContext} from "../Contexts";
import {
    FilterBaseRequest, ImagesResponse, ImageUsageResponse, PageImagePositionResponse,
    ToastFailureMessage, ToastSuccessMessage, UpdatePageImagePositionRequest,
} from "../Models/Models";
import HttpRepository from "./HttpRepository";
import {useNavigate} from "react-router-dom";

export function ImageService() {
    let navigate = useNavigate();
    let {setToast}: any = useContext(ToastContext);
    let { setHasChanges } : any = useContext(ChangesContext);

    async function uploadImages(formData: FormData, isPopUp: boolean, onClose: any): Promise<void> {
        try {
            await HttpRepository.uploadImages(formData);
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotSaved});
            return;
        }

        setToast({message: ToastSuccessMessage.dataSaved});

        if(isPopUp) {
            onClose();
            return;
        }

        navigate("/image/table");
    }

    async function filterImages(request: FilterBaseRequest): Promise<ImagesResponse> {
        try {
            return (await HttpRepository.filterImages(request)).data;
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    async function checkImageUsage(id: number): Promise<ImageUsageResponse> {
        try {
            return (await HttpRepository.checkImageUsage(id)).data;
        } catch (error) {
            setToast({message: ToastFailureMessage.error});
        }
    }

    async function updateImage(imageId: number, newAltText: string): Promise<void> {
        try {
            const response = await HttpRepository.updateImage(imageId, newAltText);
            if (response.data.hasFrontendChanges) 
                setHasChanges(true);
        } catch (error) {
            setToast({message: ToastFailureMessage.changesNotSaved});
            throw Error (error);
        }

        setToast({message: ToastSuccessMessage.changesSaved});
    }

    async function getPageImage(positionId: number): Promise<PageImagePositionResponse> {
        try {
            return (await HttpRepository.getPageImage(positionId)).data;
        } catch (error) {
            if (error.message.includes("404")) {
                navigate("/404")
                return;
            }
            setToast({message: ToastFailureMessage.dataNotLoaded});
            throw Error (error);
        }
    }

    async function updatePageImage(request: UpdatePageImagePositionRequest): Promise<void> {
        try {
            await HttpRepository.updatePageImage(request);
            setHasChanges(true);
            navigate("/home");
        } catch (error) {
            setToast({message: ToastFailureMessage.changesNotSaved});
            throw Error (error);
        }

        setToast({message: ToastSuccessMessage.changesSaved});
    }

    async function deleteImage(id: number): Promise<void> {
        try {
            const response = await HttpRepository.deleteImage(id);
            if (response.data.hasFrontendChanges) setHasChanges(true);
        } catch (error) {
            setToast({message: ToastFailureMessage.changesNotSaved});
            throw Error (error);
        }

        setToast({message: ToastSuccessMessage.changesSaved});
    }

    return {uploadImages, filterImages, checkImageUsage, updateImage, getPageImage, updatePageImage, deleteImage}
}